import { Container, AppBar, Typography, TextField, Modal, Box, Button, Toolbar, Paper } from '@mui/material'
import React, { useState } from 'react'
import LoadingBar from 'react-top-loading-bar';
import { Navigate, useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function AddOccupation() {
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  let navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalType, setModalType] = useState('success');
  const [newoccupation, setNewoccupation] = useState('');
  const [loadingBarProgress, setLoadingBarProgress] = useState('');

  const handleSave = async () => {
    try {
      setLoadingBarProgress(30);
      const url = process.env.REACT_APP_BASE_URL;
      const apiUrl = `${url}/Occupation`;
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
        body: JSON.stringify({
          occupationName: newoccupation,
        }),
      });

      const data = await response.json();
      setLoadingBarProgress(100);

      const message = (data && (data.msg || data.message)) || 'Occupation has been added successfully.';
      const status = (data && data.status && data.status.toString().toLowerCase()) || '';
      const lowerMsg = (message || '').toString().toLowerCase();
      const errorKeywords = ['already exist', 'already exists', 'failed', 'error', 'unable', 'cannot'];
      const messageHasError = status.includes('failed') || errorKeywords.some(k => lowerMsg.includes(k));

      setModalType(messageHasError ? 'error' : 'success');
      setModalMessage(message);
      setModalOpen(true);

      if (!messageHasError) {
        setNewoccupation('');
      }
    } catch (error) {
      setLoadingBarProgress(0);
      console.error('API request error:', error);
      setSnackbarMessage('An error occured');
      setOpenSnackbar(true);
      setSnackbarSeverity("error");
    }
  };
  return (
    <Container>

      <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
        <Toolbar>
          <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
            Add Occupation
          </Typography>
        </Toolbar>
      </AppBar>
      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>

        <div
          className="row g-3 align-items-center"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: '100%'
          }}
        >
          <div class="col-md-8" style={{ width: '100%' }}>

            <TextField
              fullWidth
              label="Occupation"
              id="occupationname"
              sx={{ marginBottom: 3 }}
              value={newoccupation}
              required
              onChange={(e) => setNewoccupation(e.target.value)}
            />

          </div>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
          }}
        >

          <Button
            variant="contained"
            color="primary"
            sx={{ mx: 1 }} disabled={!newoccupation} onClick={handleSave}>
            <b>SAVE</b>
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => { setNewoccupation("") }}
          >
            <b>RESET</b>
          </Button>
        </div>
        {/* <div class="form-group" style={{ width: "250px" }}>
      <input
        type="text"
        class="form-control"
        id="formGroupExampleInput"
        placeholder="Search"
      />
      
    </div> */}

        {/* <table class="table table-bordered" style={{marginTop:"20px"}}>
      <thead>
        <tr>
          <th scope="col">Occupation Name</th>

          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Business Man</td>

          <td>
            <button type="button" class="btn btn-warning">
              <b> EDIT</b>
            </button>
            <button
              type="button"
              class="btn btn-danger"
              style={{ marginLeft: "5px" }}
            >
              <b> DELETE</b>
            </button>
          </td>
        </tr>
      </tbody>
      <tbody>
        <tr>
          <td>House wife</td>

          <td>
            <button type="button" class="btn btn-warning">
              <b> EDIT</b>
            </button>
            <button
              type="button"
              class="btn btn-danger"
              style={{ marginLeft: "5px" }}
            >
              <b> DELETE</b>
            </button>
          </td>
        </tr>
      </tbody>
      <tbody>
        <tr>
          <td>Private Job</td>

          <td>
            <button type="button" class="btn btn-warning">
              <b> EDIT</b>
            </button>
            <button
              type="button"
              class="btn btn-danger"
              style={{ marginLeft: "5px" }}
            >
              <b> DELETE</b>
            </button>
          </td>
        </tr>
      </tbody>
      <tbody>
        <tr>
          <td>Driver</td>

          <td>
            <button type="button" class="btn btn-warning">
              <b> EDIT</b>
            </button>
            <button
              type="button"
              class="btn btn-danger"
              style={{ marginLeft: "5px" }}
            >
              <b> DELETE</b>
            </button>
          </td>
        </tr>
      </tbody>
    </table> */}
      </Paper>

      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        aria-labelledby="response-modal-title"
        aria-describedby="response-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: modalType === 'error' ? '#8B0000' : '#0B1F40', padding: '12px 16px' }}>
            <Typography id="response-modal-title" variant="h6" sx={{ color: '#fff' }}>
              {modalType === 'error' ? 'Error ❌' : 'Occupation Added ✅'}
            </Typography>
          </Box>

          <Box sx={{ padding: '20px' }}>
            <Typography id="response-modal-description" sx={{ mb: 2 }}>
              {modalMessage || (modalType === 'error' ? 'An error occurred.' : 'Occupation has been added successfully.')}
            </Typography>

            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setModalOpen(false);
                  if (modalType !== 'error') navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>

<Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  )
}

export default AddOccupation